import MarkupSwitcherContainer from './markup-switcher.container';

export default MarkupSwitcherContainer;
